"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fmko_ts_common_1 = require("fmko-ts-common");
/**
 * @deprecated Use {@link LabeledFieldWidget} instead.
 */
class InputWidget extends fmko_ts_common_1.Widget {
    constructor(element, updateOnInputChange = true, decorateElement = true) {
        super();
        this.handlerManager = new fmko_ts_common_1.HandlerManager();
        if (!element) {
            this.element = document.createElement("input");
            this._input = this.element;
        }
        else {
            this.element = element;
            this._input = element;
        }
        if (decorateElement) {
            this.decorateElement(this.getInput());
        }
        this.getInput().addEventListener("change", (e) => {
            if (updateOnInputChange) {
                this.setValue(this.parseValueFromInput(this.getInput().value), true);
            }
        });
    }
    getValue() {
        return this.value;
    }
    getInput() {
        return this._input;
    }
    setValue(value, fireEvents = false) {
        if (value !== this.value) {
            const previous = this.value;
            this.value = value;
            this.setValueOnInput(value, this.getInput());
            if (fireEvents) {
                fmko_ts_common_1.ValueChangeEvent.fireIfNotEqual(this, previous, value);
            }
        }
    }
    addKeyUpListener(listener) {
        this.getInput().addEventListener("keyup", listener);
    }
    addKeyDownListener(listener) {
        this.getInput().addEventListener("keydown", listener);
    }
    addKeyPressListener(listener) {
        this.getInput().addEventListener("keypress", listener);
    }
    addPasteListener(listener) {
        this.getInput().addEventListener("paste", listener);
    }
    addOnFocusHandler(handler) {
        this.getInput().addEventListener("focus", handler);
    }
    addOnBlurHandler(handler) {
        this.getInput().addEventListener("blur", handler);
    }
    addValueChangeHandler(handler) {
        return this.handlerManager.addHandler(handler);
    }
    fireEvent(event) {
        this.handlerManager.fireEvent(event);
    }
    setEnabled(enabled) {
        this.getInput().toggleAttribute("disabled", !enabled);
    }
    isEnabled() {
        return !this.getInput().hasAttribute("disabled");
    }
    /**
     * Clears the specified time.
     */
    clearValue() {
        this.getInput().value = null;
        this.value = null;
    }
    /* from Focusable interface. */
    getTabIndex() {
        return this.getInput().tabIndex;
    }
    /* from Focusable interface. */
    setTabIndex(tabIndex) {
        this.getInput().tabIndex = tabIndex;
    }
    /* from Focusable interface. */
    setAccessKey(key) {
        this.getInput().accessKey = key;
    }
    /* from Focusable interface. */
    setFocus(focused) {
        if (focused) {
            this.getInput().focus();
        }
        else {
            this.getInput().blur();
        }
    }
    wrapInput() {
        if (this.element.tagName.toLowerCase() !== "div") {
            const old = this.element;
            this.element = document.createElement("div");
            const parent = old.parentNode;
            if (parent) {
                parent.replaceChild(this.element, old);
            }
            this.element.appendChild(this.getInput());
        }
        return this.element;
    }
}
exports.default = InputWidget;
//# sourceMappingURL=InputWidget.js.map